import { Typography } from "antd";

export type T_OnboardingLoaderProps = { title?: string; desc?: string };

export default function OnboardingLoader({
  title = "Let's see what you have",
  desc = "Our intelligent bots are scanning your documents",
}: T_OnboardingLoaderProps) {
  return (
    <div className="p-5">
      <div className="bg-white border border-dashed border-gray-300 p-6 flex flex-col items-center justify-center mx-auto max-w-[900px] rounded-xl">
        <img role="presentation" src="/loader.svg" className="animate-bounce" />
        <Typography.Title level={5}>{title}</Typography.Title>
        <Typography.Text type="secondary" className="mb-4">
          {desc}
        </Typography.Text>
        <div className="progress_loader w-full" />
      </div>
    </div>
  );
}
